import React, {useCallback} from 'react'
import {formatDate} from '../../../../../../../utils/util';

const componentName = "previsitChartVisitDue";
const VisitsDue = ({ patient }) => {

   const checkFilter = useCallback((currentStatus) => {
    return currentStatus === "Open" || currentStatus === "Scheduled Appointment" 
    || currentStatus === "Ordered" || currentStatus === "Patient Refused" 
    || currentStatus === "Left Message" || currentStatus === "Referred" || currentStatus === "Pending Documentation"
    || currentStatus === "Changed PCP's" || currentStatus === "Unable to Contact"
    || currentStatus === "Unscheduled Appointment";
  },[])

  const getSuffixFromDisplay = useCallback((gapAndYear) => {
   return ` (${gapAndYear?.split(" ")?.[1]?.split(".")?.[0]})`
  },[])

  const isOpen = useCallback((arr) => {
    return arr?.some(e=>checkFilter(e.careGapStatus))
  },[checkFilter])

  const isCCMGap = useCallback((visit) => {
    return visit?.abbreviation === "CCM" || visit?.gapAndYear?.includes("CCM");
  }, []);

  return (
    <>
      {patient.careVisitDtos && patient.careVisitDtos.length > 0 && isOpen(patient.careVisitDtos) ? (
        <div className="bg-light rounded-3 p-3 mb-3">
          <h5 id={`${componentName}-visitsDue`} className="fs-5 fw-bold mb-1">Visits Due</h5>
          <div id={`${componentName}-visits`} className="d-flex justify-content-start flex-wrap">
            {patient?.careVisitDtos?.map((e, idx) =>(checkFilter(e?.careGapStatus)) &&
              <div key={`${patient.name}-${idx}`} id={`${componentName}-visit-${idx}`} className="w-50 mb-2">
                <div className="d-flex align-items-start">
                  <input id={`${componentName}-visitCheck`} className="form-check-input opacity-100 me-3" type="checkbox" value="" disabled />
                  <div>
                    <div id={`${componentName}-visitName`} className="fw-bold">{e?.name}{e?.abbreviation === 'HRM' ? getSuffixFromDisplay(e?.gapAndYear) :""}</div>
                    {e?.chronicConditionName && (
                      <small id={`${componentName}-chronicConditionName`} className="fst-italic d-block">{e?.chronicConditionName}</small>
                    )}
                    {!!e?.dueDate && !isCCMGap(e) && (
                      <small id={`${componentName}-dueByDate`} className="nowrap d-block">Follow up by {formatDate(e?.dueDate)}</small>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : null}
    </>
  )
}

export default VisitsDue
